type BillingUserMessageProps = {
  message: string;
  variant: 'warning' | 'destructive';
  title?: string;
};

const variantClass: Record<BillingUserMessageProps['variant'], string> = {
  warning:
    'border-amber-500/35 bg-amber-500/10 text-amber-950 dark:text-amber-100 [&_.title]:text-amber-900 dark:[&_.title]:text-amber-50',
  destructive:
    'border-red-500/35 bg-red-500/10 text-red-950 dark:text-red-100 [&_.title]:text-red-900 dark:[&_.title]:text-red-50',
};

export const BillingUserMessage = ({ message, variant, title }: BillingUserMessageProps) => {
  return (
    <div
      role="status"
      className={`rounded-xl border px-4 py-3 text-sm leading-relaxed ${variantClass[variant]}`}
    >
      {title ? <p className="title font-semibold mb-1">{title}</p> : null}
      <p className="whitespace-pre-wrap">{message}</p>
    </div>
  );
};
